import { render, staticRenderFns } from "./GearsSVG.vue?vue&type=template&id=78bff126&scoped=true"
import script from "./GearsSVG.vue?vue&type=script&lang=js"
export * from "./GearsSVG.vue?vue&type=script&lang=js"
import style0 from "./GearsSVG.vue?vue&type=style&index=0&id=78bff126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bff126",
  null
  
)

export default component.exports